import React, { useEffect, useState } from 'react';
import whatsapp_placeholder from '../assets/images/whatsapp_placeholder.png';
import useSnackbar from "../components/Snackbar/UseSnackbar";
import axios from 'axios';
import { API_DOMAIN } from '../components/constants';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import Avatar from '@mui/material/Avatar';
import { Stack, Tooltip } from '@mui/material';
import { Badge, Divider, Image, Input } from 'antd';
import { useCommonApiCall } from '../components/Api/commonApiCall';
import person_avatar from '../assets/person_avatar.svg'
import loading_fountain from '../assets/images/Fountain.gif'
import loading_circle_eclipse from '../assets/images/loading_circle_eclipse.svg'
import { PlusCircleOutlined } from '@ant-design/icons';
function WhatsappMessages() {

    const { CommonApiCall } = useCommonApiCall()

    const { SuccessSnackbar, ErrorSnackbar, InfoSnackbar, WarningSnackbar, ToastContainer } = useSnackbar();


    const [chatlist, setChatlist] = useState([]);
    const [continuationToken, setContinuationToken] = useState(null);
    const [chatlistLoading, setChatlistLoading] = useState(true);
    const [chatWindowLoading, setChatWindowLoading] = useState(true);
    const [selectedChat, setSelectedChat] = useState(null);
    const [selectedChatExchanges, setSelectedChatExchanges] = useState([]);


    function stringToColor(string) {
        let hash = 0;
        let i;

        /* eslint-disable no-bitwise */
        for (i = 0; i < string.length; i += 1) {
            hash = string.charCodeAt(i) + ((hash << 5) - hash);
        }

        let color = '#';

        for (i = 0; i < 3; i += 1) {
            const value = (hash >> (i * 8)) & 0xff;
            color += `00${value.toString(16)}`.slice(-2);
        }
        /* eslint-enable no-bitwise */

        return color;
    }

    function stringAvatar(name) {
        if (!name) {
            return "";
        }
        if (name.split(' ').length === 2) {
            // If name has two parts (first name and last name)
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0]}${name.split(' ')[1][0]}`,
            };
        } else {
            // If name has only one part
            return {
                sx: {
                    bgcolor: stringToColor(name),
                },
                children: `${name.split(' ')[0][0].toUpperCase()}`, // Capitalize first letter
            };
        }
    }


    const getAllChats = async () => {
        setChatlistLoading(true);
        try {
            const response = await CommonApiCall({
                api_key: "uzdpart"
            }, "wati_messages/fetch_messages", "post");
            if (response.status) {
                setChatlist(response.data.final_data);
                setContinuationToken(response.data.continuationToken);
                SuccessSnackbar(`Retrieved chats`);
            }
        } catch (error) {
            ErrorSnackbar(error.message);
        }
        finally {
            setChatlistLoading(false);
        }
    }

    useEffect(() => {
        getAllChats();
    }, []);

    const formatChatMessageTime = (epoch) => {
        if (!epoch)
            return null
        const date = new Date(epoch * 1000);
        const now = new Date();

        // Check if it's today by comparing Year, Month, and Date
        const isToday =
            date.getDate() === now.getDate() &&
            date.getMonth() === now.getMonth() &&
            date.getFullYear() === now.getFullYear();

        const timeOptions = {
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        };

        if (isToday) {
            return new Intl.DateTimeFormat('default', timeOptions).format(date);
        } else {
            // For older messages, include the date (e.g., "Feb 15, 12:02 PM")
            return new Intl.DateTimeFormat('default', {
                month: 'short',
                day: 'numeric',
                ...timeOptions
            }).format(date);
        }
    };

    const set_selected_chat_state = async (chatId) => {
        setSelectedChat(chatId)
        setChatWindowLoading(true);
        try {
            const response = await CommonApiCall({
                chatId,
                lastMessageId: null
            }, "wati_messages/fetch_specific_chat_messages", "post");
            if (response.status) {
                setSelectedChatExchanges(response.data.data.reverse());
                // SuccessSnackbar(`Retrieved chats`);
            }
        } catch (error) {
            ErrorSnackbar(error.message);
        }
        finally {
            setChatWindowLoading(false);
        }
    }

    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape') {
                setSelectedChat(null);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    const formatWhatsAppText = (text) => {
        if (!text)
            return null;
        // Regex to capture: *bold*, _italic_, ~strikethrough~, and ```monospace```
        const regex = /(\*.*?\*|__.*?__|~.*?~|```.*?```)/g;

        const parts = text.split(regex);

        return parts.map((part, index) => {
            if (!part) return null;

            // Monospace: ```text```
            if (part.startsWith('```') && part.endsWith('```')) {
                return (
                    <code key={index} className="bg-gray-100 p-0.5 rounded font-mono text-xs">
                        {part.slice(3, -3)}
                    </code>
                );
            }
            // Bold: *text*
            if (part.startsWith('*') && part.endsWith('*')) {
                return <strong key={index} className="font-bold">{part.slice(1, -1)}</strong>;
            }
            // Italic: __text__ or _text_
            if ((part.startsWith('__') && part.endsWith('__')) || (part.startsWith('_') && part.endsWith('_'))) {
                const content = part.startsWith('__') ? part.slice(2, -2) : part.slice(1, -1);
                return <em key={index} className="italic">{content}</em>;
            }
            // Strikethrough: ~text~
            if (part.startsWith('~') && part.endsWith('~')) {
                return <span key={index} className="line-through text-gray-400">{part.slice(1, -1)}</span>;
            }

            // Plain text
            return part;
        });
    };
    return (
        <>

            <div className='border rounded drop-shadow-2 p-2' style={{ backgroundColor: "#ebebeb" }}>
                <div className='flex'>
                    {/* left pane */}
                    <div className='mr-2 border rounded' style={{ backgroundColor: "#cacbcc" }}>

                        {/* This div contains the chats list on the left pane */}
                        <div className='flex justify-center'>

                            <div className='flex align-middle justify-center border rounded mt-2 mb-0' style={{ backgroundColor: "white", width: "300px" }}>
                                <Input
                                    allowClear
                                    type='text'
                                    placeholder='Search'
                                    style={{ borderColor: "gray", width: "100%" }}
                                />
                            </div>
                        </div>
                        <div className='flex justify-between mr-3 ml-3 align-middle italic' style={{ fontSize: "10px" }}>
                            <div>Unread : {chatlist.filter(chat => chat.unreadCount > 0).length}</div>
                            <div>Total : {chatlist.length || 0}</div>
                        </div>

                        <Divider className='mt-0 mb-0 p-0' />

                        {/* Chatlist starts here */}
                        <div className='overflow-y-auto overflow-ellipsis mt-1 p-1' style={{ height: "70vh" }}>
                            {
                                chatlistLoading
                                    ?
                                    <div className='flex justify-center'>
                                        <img src={loading_fountain} />
                                    </div>
                                    :
                                    chatlist.length > 0 ?
                                        chatlist.map((chat) => (
                                            <div className="m-1.5 p-1 border rounded drop-shadow cursor-pointer hover:scale-105 active:scale-95 transition-transform duration-100 ease-in-out select-none" style={{ width: "300px", height: "80px", backgroundColor: `${selectedChat == chat.id ? '#7bfc68' : 'white'}` }} onClick={() => set_selected_chat_state(chat.id)}>
                                                <div className="flex">
                                                    <img style={{ width: "40px", height: "40px", borderRadius: "20px" }} src={person_avatar} alt="DP" loading="lazy" />
                                                    <div className="pl-1" style={{ width: "130px" }}>
                                                        {/* name and last message preview part */}
                                                        <div className='flex' style={{ width: "199%" }}>
                                                            <div className="truncate w-[230px] font-semibold">{chat.name}</div>
                                                            <Badge className='mr-1' id={'unread' + chat.whatsappId} count={chat.unreadCount} style={{ backgroundColor: '#52c41a' }}></Badge>
                                                        </div>
                                                        {/* <div className="italic" style={{ fontSize: "10px", color: "gray" }}>{chat.whatsappId}</div> */}
                                                        <div className='flex' style={{ width: "199%" }}>
                                                            <div id={'text' + chat.whatsappId} className="w-[230px] font-semibold line-clamp-2 overflow-hidden" style={{ fontSize: "12px", color: "gray" }}>{chat.text}</div>
                                                            <div className='flex align-bottom' style={{ fontSize: "10px", color: "gray", width: "50px" }}>{formatChatMessageTime(chat.lastMessageDate)}</div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                        :
                                        <div className='m-1.5 italic flex justify-center' style={{ width: "300px", height: "80px" }}>No chats found</div>
                            }


                        </div>

                    </div>

                    {/* right pane */}
                    <div className='border rounded pl-2 pr-2 pb-2 overflow-y-auto' style={{ backgroundColor: "#cacbcc", width: "100%", height: "80vh" }}>

                        {
                            selectedChat ?
                                chatWindowLoading ?
                                    <div className='flex justify-center' style={{ height: "100%" }}>
                                        <img style={{ width: "30%" }} src={loading_circle_eclipse} />
                                    </div> :
                                    <div className='pl-2 pr-2 pb-2'>
                                        <div>
                                            <div className='bg-white mt-0 flex rounded items-center sticky top-3 pl-2 z-10' style={{ height: "80px" }}>
                                                <img style={{ width: "40px", height: "40px", borderRadius: "20px" }} src={person_avatar} alt="DP" loading="lazy" />
                                                <div>
                                                    <div className='ml-3' style={{ fontSize: "16px" }}>
                                                        {chatlist.filter((value) => value.id == selectedChat)[0].name}
                                                    </div>
                                                    <div className='ml-3 italic flex justify-center' style={{ fontSize: "12px" }}>
                                                        {chatlist.filter((value) => value.id == selectedChat)[0].whatsappId}
                                                    </div>
                                                </div>
                                            </div>
                                            <Divider className='mt-3 mb-2 p-0' />
                                            <Tooltip title='Load previous chats'>
                                                <div className='flex justify-center cursor-pointer hover:bg-bodydark rounded mr-60 ml-60 pt-2 pb-2 active:scale-95 transition-transform'>
                                                    <PlusCircleOutlined />
                                                </div>
                                            </Tooltip>
                                            {selectedChatExchanges.map((chat) => (
                                                chat.eventType == 'ticket'
                                                    ?
                                                    <div className='flex p-2 justify-center'>
                                                        <Divider>
                                                            {chat?.eventDescription + ' - ' + formatChatMessageTime(new Date(chat?.created).getTime() / 1000)}
                                                        </Divider>
                                                    </div>
                                                    :
                                                    < div
                                                        key={chat.id}
                                                        className='flex w-full'
                                                        style={{ justifyContent: chat.owner ? 'flex-end' : chat?.finalText ? 'flex-end' : 'flex-start' }}
                                                    >
                                                        <div className={`whitespace-pre-wrap 
            relative mt-1 mb-1 p-2 max-w-[70%] rounded-lg border shadow-sm
            ${chat?.owner
                                                                ? 'bg-[#dcf8c6] rounded-br-none mr-2 after:border-l-[10px] after:border-l-[#dcf8c6]'
                                                                : chat?.finalText ? 'bg-[#dcf8c6] rounded-br-none mr-2 after:border-l-[10px] after:border-l-[#dcf8c6]' : 'bg-white rounded-bl-none ml-2 after:border-r-[10px] after:border-r-white'}
            after:content-[''] after:absolute after:bottom-0 
            ${chat?.owner ? 'after:-right-2' : chat?.finalText ? 'after:-right-2' : 'after:-left-2'} 
            after:w-0 after:height-0 after:border-t-[10px] after:border-t-transparent
        `}>
                                                            {chat.type == 'image'
                                                                ?
                                                                <div className='flex justify-center'>
                                                                    <Image
                                                                        style={{
                                                                            maxHeight: "250px"
                                                                        }}
                                                                        className='rounded'
                                                                        src={chat.data} />
                                                                </div>
                                                                : null}
                                                            {chat.type == 'video'
                                                                ?
                                                                <div className='flex justify-center'>
                                                                    <video src={chat.data} width="640" height="360" controls>
                                                                        Your browser does not support the video tag.
                                                                    </video>
                                                                </div>
                                                                : null}
                                                            {chat?.replySourceMessage
                                                                ?
                                                                <div className='flex border rounded bg-white mb-1'>
                                                                    <div style={{ width: "2px", backgroundColor: "#8349e6", height: "auto" }}></div>
                                                                    <div className='line-clamp-4 overflow-hidden'>
                                                                        {formatWhatsAppText(chat?.replySourceMessage?.text)}
                                                                    </div>
                                                                </div>
                                                                : null}
                                                            {formatWhatsAppText(chat?.text || chat?.finalText)}

                                                            {/* Optional: Add the timestamp inside the bubble */}
                                                            <div className="text-[10px] text-gray-500 text-right mt-1 leading-none">
                                                                {chat?.owner && chat?.operatorName ? chat.operatorName + ' - ' : null}{formatChatMessageTime(chat?.timestamp || new Date(chat?.created).getTime() / 1000)}{chat.owner ? ' - ' + chat.statusString : null}
                                                            </div>
                                                        </div>
                                                    </div>
                                            ))}
                                        </div>
                                        {/* <div>
                                            <Input
                                                placeholder='Type message...'
                                            />
                                        </div> */}
                                    </div>
                                :
                                <div>
                                    <div className='flex justify-center'>
                                        <img src={whatsapp_placeholder} />
                                    </div>
                                    <div className='flex justify-center'>
                                        Select a chat from the left pane to dive deep
                                    </div>
                                    <div className='flex justify-center font-bold' style={{ fontSize: "16px" }}>
                                        There are {chatlist.filter(chat => chat.unreadCount > 0).length} Unread messages!!
                                    </div>
                                </div>
                        }


                    </div>


                </div>
            </div >

            <ToastContainer />
        </>

    );
};

export default WhatsappMessages;
